<template>
  <div class="container">
	  <div class="loginContent">
		  <div class="w1600">
			 <div class="loginForm p3 bd10">
			 		<h3 class="font28">{{$t("login.title")}}</h3>
			 		<p class="font18 font-light tip cor999">{{$t("login.titleTip")}}</p>
			 		<div class="form">
			 			<dl>
			 				<dd class="d-flex f-colu">
			 					<div class="label font-medium">{{$t("commom.username")}}</div>
			 					<div class="enter">
			 						<input type="text" v-model="formData.username" class="input font-light" :placeholder="$t('commom.usernamePlaceholder')">
			 					</div>
			 				</dd>
			 				<dd class="d-flex f-colu">
			 					<div class="label font-medium">{{$t("commom.password")}}</div>
			 					<div class="enter">
			 						<input @keyup.enter="login" type="password" v-model="formData.password" class="input font-light" :placeholder="$t('commom.passwordPlaceholder')">
			 					</div>
			 				</dd>
			 			</dl>
			 		</div>
			 		<div class="changePassword d-flex j-sb">
			 			<p class="d-flex a-center pointer" @click="remmenber = !remmenber"><span :class="['pointer checkbox', {active:remmenber}]"></span>{{$t("login.remmenber")}}</p>
			 			<a class="pointer link" @click="goToPage('/findPassword')">{{$t("login.forgotPassword")}}</a>
			 		</div>
			 		<div class="submit d-flex f-colu">
			 			<button class="fmBtn w100 font20 font-medium pointer" @click="checkVerify">{{$t("login.title")}}</button>
			 			<p class="d-flex j-end">{{$t("login.noAccount")}}？<a class="pointer" @click="goToPage('/register')">{{$t("login.registerNow")}}</a></p>
			 		</div>
			 </div>
		  </div>
	  </div>
	  <!-- 验证码弹窗 -->
	  <verify :show="showVerify" @success="handleVerify"></verify>
	  <!-- 弹窗提示 -->
	  <popup v-show="popupHandle">
	  	<div class="slot d-flex f-colu j-center a-center line-md">
	  		<img src="@/assets/Icons/error.png" alt="">
	  		{{message}}
	  	</div>
	  </popup>
  </div>
</template>

<script>
// vuex
import { mapMutations } from 'vuex'
export default {
  name: 'Login',
  data() {
    return {
		remmenber: false, // 是否记住密码
		message: '', // 提示
		popupHandle: false, // 控制提示弹窗是否显示
		// 登录表单
		formData: {
			username: '',
			password: ''
		},
		showVerify:false
	}
  },
  
  created() {
	  // 获取本地存储密码
	  if(localStorage.getItem('username') && localStorage.getItem('password')) {
		  this.remmenber = true;
		  this.formData.username = localStorage.getItem('username');
		  this.formData.password = decodeURIComponent(escape(atob(localStorage.getItem('password'))));
	  }
  },
  mounted(){
	this.$nextTick(function(){
		$('.code_msg').on('click',function(e){
            if(!$(e.target).closest('.code_sub').length){
                $('#captcha').html(' ')
                $('.code_msg').hide()
            }else{ }
        })
	})
  },
  
  methods: {
	  // vuex
	  ...mapMutations(['changeState']),
	  
	  tableContent(index) {
		  this.currentContent = index;
	  },
	  
	  // 页面跳转
	  goToPage(path, query={}) {
		  this.$router.push({
			path,
			query
		  })
	  },
	  getPermissions:function(){
		var that=this;
		this.$axios.get('member/permissions').then(res=>{
			if(res.data){
				localStorage.setItem("permissions", JSON.stringify(res.data));
				that.changeState({
					permissions: res.data,
				});
			}
		});
	  },
	  getCodeImage(){
		this.$sysapi.get('system/captcha/get',{
			headers:{'captchaType':'blockPuzzle'}
		}).then(res=>{

		})
	  },
	  checkVerify(){
		let that = this;
		// 验证邮箱/密码是否填写
		if(!this.formData.username.trim() || !this.formData.password.trim()) {
			this.message = this.$t('login.usernameEmpty');
			this.popupHandle = true;
			return;
		};
		that.showVerify=true;
	  },
	  handleVerify(){
		var that=this;
		that.showVerify=false;
		that.login();
	  },
	  // 登录
	  login() {
		  let that = this;
		
		let formData = new FormData();
		// 遍历对象进行枚举
		Object.keys(that.formData).forEach(function(key) {
		   formData.append(key, that.formData[key]);
		});
		that.$axios({
		  method: 'post',
		  url: 'verifyMember/login',
		  headers: {'Content-Type':'multipart/form-data'},
		  data: formData
		}).then(res => {
			
			// Token
			if(res.data.token){
				localStorage.setItem("Authorization", res.data.token);
				that.getPermissions();
			};
			// 存储用户信息
			if(res.data.member){
				localStorage.setItem("member", JSON.stringify(res.data.member));
				localStorage.setItem("isLogin", 'true');
				// 修改store
				that.changeState({
					member: res.data.member,
					isLogin: 'true',
					Authorization: res.data.token
				});
			};
			// 密码是否过期
			if(res.data.isUpdatePassword){
				localStorage.setItem("isUpdatePassword", res.data.isUpdatePassword);
			}
			// 判断头像是否存在，不存在则使用默认
			if(res.data.member.cover) {
				localStorage.setItem("avatar", res.data.member.cover);
				that.changeState({
					avatar: res.data.member.cover,
				});
			};
			// 用户是否记住密码
			if(that.remmenber) {
				localStorage.setItem('password', btoa(unescape(encodeURIComponent(that.formData.password))));
				localStorage.setItem('username', that.formData.username);
			}else{
				// 如果没有记住密码 那么移除本地的password的存储情况
				localStorage.removeItem('password');
				localStorage.removeItem('username');
			};
			if(res.data&&res.code==206){
				// let msg=res.message;
				// that.$message({
				// 	message: msg,
				// 	type: 'warning'
				// });
				that.message = res.message;
				that.popupHandle = true;
				var timer=setTimeout(function(){
					that.popupHandle = false;
					that.$router.push('/changePassword');
					clearTimeout(timer);
				},1000)
			}else{
				that.$message({
					message: that.$t('login.success'),
					type: 'success'
				});
				let backurl=localStorage.getItem('backurl');
				if(backurl&&backurl!='/'){
					that.$router.push(backurl);
				}else{
					that.$router.push('/adminIndex');
				}
				
			};
			
		})
		.catch(err => {});
	  }
  }
}
</script>

<style lang="less" scoped>

	.container{
		background: #f2f5fa;
	}
	.loginContent{
		padding: .6rem 0;
	}
	.loginForm{
		max-width: 500px;
		width: 100%;
		padding-top: .5rem;
		padding-bottom: .5rem;
		border-radius: 0;
		margin: 0 auto;
		.tip{
			margin: .15rem 0 .4rem;
		}
		dl{
			dd{
				.label{
					margin-bottom: .1rem;
				}
				&:not(:last-child) {
					margin-bottom: .3rem;
				}
				.input{
					border-radius: 0;
				}
			}
		}
		.submit{
			.fmBtn{
				letter-spacing: 2px;
			}
			p{
				margin-top: .4rem;
				a{
					color: #224ed9;
					padding-bottom: .1rem;
					border-bottom: solid 1px #224ed9;
				}
			}
		}
		.changePassword{
			margin: .15rem 0 .3rem;
			.checkbox{
				border: solid 1px #eee;
			}
		}
	}
</style>
